<template>
    <LayoutBase>
        <div class="c-event-form">
            <header id="content__header">
                <h1>Thank you</h1>
            </header>

            <div>
                <p>Successfully registered to {{ event.eventName }}</p>
            </div>
        </div>
    </LayoutBase>
</template>
<script>
import LayoutBase from './Layout/LayoutBase.vue';
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'PageThanks',
    components: {
        LayoutBase
    },
    computed: {
        ...mapState({
            event: state => state.event,
            user: state => state.auth.user,
            impersonating: state => state.auth.impersonating,
        }),
        ...mapGetters([
            'can',
        ])
    },
}
</script>

<style scoped>

</style>
